import { render, staticRenderFns } from "./informaton.vue?vue&type=template&id=a1574652&"
import script from "./informaton.vue?vue&type=script&lang=js&"
export * from "./informaton.vue?vue&type=script&lang=js&"
import style0 from "./informaton.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports